import React from 'react'

import { useCallbackStatic } from '../../hooks/utils'

import Base from './Base'

const DiaDosNamorados = () => {

    const goToMidias = useCallbackStatic(() => {
        const message = {type: 'navigate', url: 'vocenarpc://enviodemidia/14', local: 'site', version: 2.0}
        console.log(message)
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify(message)); 
        }
    })

    return (
        <Base
            title="Envie a sua declaração de amor para o Dia dos Namorados!"
            description={() => (
                <span>Se quiser mandar uma foto ou vídeo <a onClick={goToMidias}>clique aqui</a></span>
            )}
            imagePath="/imgs/diadosnamorados.png"
            programName="Dia dos Namorados"
            customFirebaseCollection="misc"
            customFirebaseControlKey="interatividade-jornalismo-misc"
        />
    )
}

export default DiaDosNamorados
